import { gql } from '@apollo/client';

export const FETCH_ALL_PRIOR_AUTHORIZATION_QUERY = gql`
  query fetchAllPriorAuthorization($sourceUrl: String) {
    fetchAllPriorAuthorization(sourceUrl: $sourceUrl) {
      id
      status
      priority
      category {
        text
        system
        code
      }
      quantityQuantity {
        unit
      }
      occurrencePeriod {
        start
        end
      }
      requester {
        reference
        display
      }
      authoredOn
      subject {
        reference
        display
      }
      category {
        coding {
          system
          code
          display
        }
      }
      code {
        coding {
          system
          code
          display
        }
      }
      identifier {
        use
        system
        value
      }
    }
  }
`;

export const FETCH_PRIOR_AUTHORIZATION_BY_ID = gql`
  query fetchPriorAuthorizationById($priorAuthId: String) {
    fetchPriorAuthorizationById(priorAuthId: $priorAuthId) {
      serviceRequestResource
      docArn
    }
  }
`;
